import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
    data() {
        return {
            opened: false
        };
    }
})

export default class NotificationBar extends Vue {
    @Prop(Boolean)
    value: boolean;

    @Prop(Number)
    eventId: number;

    @Prop({ default: '#ff5252' })
    snackbarColor: string

    @Prop({ type: Number, default: -1 })
    timeout: number

    opened: boolean;

    @Watch('value')
    onValueChange(value: boolean) {
        this.opened = value;
    }

   @Watch('opened')
    onChange(value) {
        this.$emit('input', value);
    }

   closeSnackbar() {
       this.$emit('notification:close');
   }
}
